<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      statusHeight: 0,
      navBarHiehgt: 0
    };
  },
  beforeCreate() {
    this.$plusExtends(() => {
      //获取状态栏高度
      //let lh = window.plus.navigator.getStatusbarHeight();
      this.statusHeight = 0;
      //获取导航栏高度
      let os = window.plus.os.name;
      if (os.indexOf("iOS") > -1) {
        this.navBarHiehgt = 48;
      } else {
        this.navBarHiehgt = 44;
      }
      let flag = window.plus.navigator.isImmersedStatusbar();
      console.log(flag);
      let ws = window.plus.webview.currentWebview();
      console.log("当前Webview窗口：" + ws.getURL());

      window.plus.navigator.setStatusBarBackground("#eee");
      //window.plus.runtime.quit();
    });
  },
  methods: {
    closeUni() {
      this.$plusExtends(() => {
        window.plus.runtime.quit();
      });
    }
  }
};
</script>
<style lang="scss">
body,
ul,
li {
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.nav-container {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  background-color: red;
  .status {
    background-color: blue;
  }
  .nav-bar {
    background-color: #eee;
    .close-btn {
      width: 42px;
      height: 42px;
    }
  }
}
.content {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  overflow-y: scroll;
}
</style>
